module.exports = __webpack_public_path__ + "img/9_reinhard_015.b2ec743a.png";